<template>
  <div
    class="menu-link"
    :class="[{'menu-link--widget' : item.additional}, {'menu-link--desktop-hidden' : item.isVisibleOnMobile}]"
  >
    <template v-if="item.title">
      <a
        v-if="item.externalTypeOfLink"
        class="menu-link__title"
        :href="item.url.path ? item.url.path : ''"
        rel="noopener noreferrer"
        target="_blank"
        @click="$emit('closeMenu')"
      >
        <component
          v-if="icon"
          :is="icon.componentName"
          class="menu-link__title-icon"
        ></component>
        <svg-stub
          v-else
          class="menu-link__title-icon"
        ></svg-stub>
        <span v-html="item.title"></span>
      </a>
      <nuxt-link
        v-else
        class="menu-link__title"
        :to="{
          path: localePath(item.url.path ? `${item.url.path}` : ''),
          hash: item.url.hash ? `${item.url.hash}` : ''
        }"
        @click.native="$emit('closeMenu')"
      >
        <component
          v-if="icon"
          :is="icon.componentName"
          class="menu-link__title-icon"
        ></component>
        <svg-stub
          v-else
          class="menu-link__title-icon"
        ></svg-stub>
        <span v-html="item.title"></span>
      </nuxt-link>
    </template>

    <div
      v-if="item.description"
      class="menu-link__description"
      v-html="item.description"
    ></div>

    <div
      v-if="item.additional"
      class="menu-link__additional"
    >
      <ul v-if="item.additional.list && !item.additional.list.isNumbered">
        <li
          v-for="item in item.additional.list.items"
          v-html="item"
        ></li>
      </ul>
      <nuxt-link
        v-if="item.additional.button"
        class="menu-link__additional-btn btn btn--xs btn--outline"
        :to="{
          path: localePath(`${item.additional.button.url.path}`),
          hash: item.additional.button.url.hash ? `${item.additional.button.url.hash}` : ''
        }"
        @click.native="$emit('closeMenu')"
      >
        {{ item.additional.button.name }}
      </nuxt-link>
      <div
        v-if="item.additional.links && item.additional.links.length > 0"
        class="menu-link__links"
      >
        <template v-for="(link, i) in item.additional.links">
          <template v-if="link.externalTypeOfLink">
            <a
              :key="i"
              class="menu-link__links-item"
              :href="link.url.path"
              rel="noopener noreferrer"
              target="_blank"
              @click="$emit('closeMenu')"
              v-html="link.name"
            ></a>
          </template>
          <template v-else>
            <nuxt-link
              :key="i"
              class="menu-link__links-item"
              :to="{
                path: localePath(link.url.path ? `${link.url.path}` : ''),
                hash: link.url.hash ? `${link.url.hash}` : ''
              }"
              @click.native="$emit('closeMenu')"
              v-html="link.name"
            ></nuxt-link>
          </template>
        </template>
      </div>
      <div
        v-if="item.additional.documents && item.additional.documents.length > 0"
        class="menu-link__documents"
      >
        <s-document
          class="menu-link__documents-item"
          v-for="(document, i) in item.additional.documents"
          :key="i"
          :link="document.url.path"
          @click="$emit('closeMenu')"
        >
          <span>{{ document.name }}</span>
        </s-document>
      </div>
    </div>
  </div>
</template>

<script>
import SvgStub from '~/assets/icons/header/dropdown-menu/stub.svg'

import SvgSelectel from '~/assets/icons/header/dropdown-menu/selectel.svg'
import SvgHome from '~/assets/icons/header/dropdown-menu/home.svg'
import SvgWeb from '~/assets/icons/header/dropdown-menu/web.svg'
import SvgSettingsRound from '~/assets/icons/header/dropdown-menu/settings-round.svg'
import SvgPhone from '~/assets/icons/header/dropdown-menu/phone.svg'
import SvgBag from '~/assets/icons/header/dropdown-menu/bag.svg'
import SvgPeople from '~/assets/icons/header/dropdown-menu/people.svg'
import SvgDoc from '~/assets/icons/header/dropdown-menu/doc.svg'
import SvgLupa from '~/assets/icons/header/dropdown-menu/lupa.svg'
import SvgBook from '~/assets/icons/header/dropdown-menu/book.svg'
import SvgFolder from '~/assets/icons/header/dropdown-menu/folder.svg'
import SvgStar from '~/assets/icons/header/dropdown-menu/star.svg'
import SvgDino from '~/assets/icons/header/dropdown-menu/dino.svg'
import SvgText from '~/assets/icons/header/dropdown-menu/text.svg'
import SvgShield from '~/assets/icons/header/dropdown-menu/shield.svg'
import SvgMarker from '~/assets/icons/header/dropdown-menu/marker.svg'
import SvgPen from '~/assets/icons/header/dropdown-menu/pen.svg'
import SvgChat from '~/assets/icons/header/dropdown-menu/chat.svg'
import SvgMail from '~/assets/icons/header/dropdown-menu/mail.svg'
import SvgCode from '~/assets/icons/header/dropdown-menu/code.svg'
import SvgSetup from '~/assets/icons/header/dropdown-menu/setup.svg'
import SvgArrowLine from '~/assets/icons/header/dropdown-menu/arrow-line.svg'
import SvgCalculate from '~/assets/icons/header/dropdown-menu/calculate.svg'
import SvgCamera from '~/assets/icons/header/dropdown-menu/camera-cctv.svg'
import SvgChartColumn from '~/assets/icons/header/dropdown-menu/chart-column.svg'
import SvgChartPie from '~/assets/icons/header/dropdown-menu/chart-pie.svg'
import SvgCloudMulti from '~/assets/icons/header/dropdown-menu/cloud-multi.svg'
import SvgCloudSquare from '~/assets/icons/header/dropdown-menu/cloud-square.svg'
import SvgCloudSquare1 from '~/assets/icons/header/dropdown-menu/cloud-square-1.svg'
import SvgCloudUpload from '~/assets/icons/header/dropdown-menu/cloud-upload.svg'
import SvgDotsDisconnected from '~/assets/icons/header/dropdown-menu/dots-disconnected.svg'
import SvgDotsFork from '~/assets/icons/header/dropdown-menu/dots-fork.svg'
import SvgDotsPath from '~/assets/icons/header/dropdown-menu/dots-path.svg'
import SvgEye from '~/assets/icons/header/dropdown-menu/eye.svg'
import SvgKuber from '~/assets/icons/header/dropdown-menu/kuber.svg'
import SvgLeftArrow from '~/assets/icons/header/dropdown-menu/left-arrow.svg'
import SvgLock from '~/assets/icons/header/dropdown-menu/lock.svg'
import SvgMouse from '~/assets/icons/header/dropdown-menu/mouse.svg'
import SvgPc from '~/assets/icons/header/dropdown-menu/pc.svg'
import SvgPercent from '~/assets/icons/header/dropdown-menu/percent.svg'
import SvgPlanet from '~/assets/icons/header/dropdown-menu/planet.svg'
import SvgProcessor from '~/assets/icons/header/dropdown-menu/processor.svg'
import SvgRadiator from '~/assets/icons/header/dropdown-menu/radiator.svg'
import SvgRightArrow from '~/assets/icons/header/dropdown-menu/right-arrow.svg'
import SvgSettings from '~/assets/icons/header/dropdown-menu/settings.svg'
import SvgTarget from '~/assets/icons/header/dropdown-menu/target.svg'
import SvgThermometer from '~/assets/icons/header/dropdown-menu/thermometer.svg'
import SvgWindowMulti from '~/assets/icons/header/dropdown-menu/window-multi.svg'
import SvgWindowNew from '~/assets/icons/header/dropdown-menu/window-new.svg'
import SvgCloudDownload from '~/assets/icons/header/dropdown-menu/cloud-download.svg'
import SvgVideo from '~/assets/icons/header/dropdown-menu/video.svg'

const icons = [
  {
    name: 'selectel',
    componentName: SvgSelectel
  },
  {
    name: 'home',
    componentName: SvgHome
  },
  {
    name: 'web',
    componentName: SvgWeb
  },
  {
    name: 'settings-round',
    componentName: SvgSettingsRound
  },
  {
    name: 'phone',
    componentName: SvgPhone
  },
  {
    name: 'bag',
    componentName: SvgBag
  },
  {
    name: 'people',
    componentName: SvgPeople
  },
  {
    name: 'doc',
    componentName: SvgDoc
  },
  {
    name: 'lupa',
    componentName: SvgLupa
  },
  {
    name: 'book',
    componentName: SvgBook
  },
  {
    name: 'folder',
    componentName: SvgFolder
  },
  {
    name: 'star',
    componentName: SvgStar
  },
  {
    name: 'dino',
    componentName: SvgDino
  },
  {
    name: 'text',
    componentName: SvgText
  },
  {
    name: 'shield',
    componentName: SvgShield
  },
  {
    name: 'marker',
    componentName: SvgMarker
  },
  {
    name: 'pen',
    componentName: SvgPen
  },
  {
    name: 'chat',
    componentName: SvgChat
  },
  {
    name: 'mail',
    componentName: SvgMail
  },
  {
    name: 'code',
    componentName: SvgCode
  },
  {
    name: 'setup',
    componentName: SvgSetup
  },
  {
    name: 'arrow-line',
    componentName: SvgArrowLine
  },
  {
    name: 'calculate',
    componentName: SvgCalculate
  },
  {
    name: 'camera',
    componentName: SvgCamera
  },
  {
    name: 'chart-column',
    componentName: SvgChartColumn
  },
  {
    name: 'chart-pie',
    componentName: SvgChartPie
  },
  {
    name: 'cloud-multi',
    componentName: SvgCloudMulti
  },
  {
    name: 'cloud-square',
    componentName: SvgCloudSquare
  },
  {
    name: 'cloud-square-1',
    componentName: SvgCloudSquare1
  },
  {
    name: 'cloud-upload',
    componentName: SvgCloudUpload
  },
  {
    name: 'dots-disconnected',
    componentName: SvgDotsDisconnected
  },
  {
    name: 'dots-fork',
    componentName: SvgDotsFork
  },
  {
    name: 'dots-path',
    componentName: SvgDotsPath
  },
  {
    name: 'eye',
    componentName: SvgEye
  },
  {
    name: 'kuber',
    componentName: SvgKuber
  },
  {
    name: 'left-arrow',
    componentName: SvgLeftArrow
  },
  {
    name: 'lock',
    componentName: SvgLock
  },
  {
    name: 'mouse',
    componentName: SvgMouse
  },
  {
    name: 'pc',
    componentName: SvgPc
  },
  {
    name: 'percent',
    componentName: SvgPercent
  },
  {
    name: 'planet',
    componentName: SvgPlanet
  },
  {
    name: 'processor',
    componentName: SvgProcessor
  },
  {
    name: 'radiator',
    componentName: SvgRadiator
  },
  {
    name: 'right-arrow',
    componentName: SvgRightArrow
  },
  {
    name: 'settings',
    componentName: SvgSettings
  },
  {
    name: 'target',
    componentName: SvgTarget
  },
  {
    name: 'thermometer',
    componentName: SvgThermometer
  },
  {
    name: 'window-multi',
    componentName: SvgWindowMulti
  },
  {
    name: 'window-new',
    componentName: SvgWindowNew
  },
  {
    name: 'cloud-download',
    componentName: SvgCloudDownload
  },
  {
    name: 'video',
    componentName: SvgVideo
  }
]

export default {
  name: 'MenuLink',
  components: {
    SvgStub,

    SvgSelectel,
    SvgHome,
    SvgWeb,
    SvgSettingsRound,
    SvgPhone,
    SvgBag,
    SvgPeople,
    SvgDoc,
    SvgLupa,
    SvgBook,
    SvgFolder,
    SvgStar,
    SvgDino,
    SvgText,
    SvgShield,
    SvgMarker,
    SvgPen,
    SvgChat,
    SvgMail,
    SvgCode,
    SvgSetup,
    SvgArrowLine,
    SvgCalculate,
    SvgCamera,
    SvgChartColumn,
    SvgChartPie,
    SvgCloudMulti,
    SvgCloudSquare,
    SvgCloudSquare1,
    SvgCloudUpload,
    SvgDotsDisconnected,
    SvgDotsFork,
    SvgDotsPath,
    SvgEye,
    SvgKuber,
    SvgLeftArrow,
    SvgLock,
    SvgMouse,
    SvgPc,
    SvgPercent,
    SvgPlanet,
    SvgProcessor,
    SvgRadiator,
    SvgRightArrow,
    SvgSettings,
    SvgTarget,
    SvgThermometer,
    SvgWindowMulti,
    SvgWindowNew,
    SvgCloudDownload,
    SvgVideo
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      icons
    }
  },
  computed: {
    icon() {
      return this.icons.find(icon => icon.name === this.item.iconName)
    }
  }
}
</script>

<style lang="scss">
.menu-link {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 360px;
  padding: 12px 0 12px 24px;
  color: $primary;

  @media (max-width: $breakpoint-lg) {
    width: 100%;
    max-width: 100%;
    padding: 16px 20px 16px 34px;

    &:not(:last-child) {
      border-bottom: 1px solid $primary10;
    }

    &:last-child {
      margin-bottom: 32px;
    }
  }

  &--widget {
    grid-row: 1 / -1;

    @media (max-width: $breakpoint-lg) {
      grid-row: auto;
    }
  }

  &--desktop-hidden {
    display: none;

    @media (max-width: $breakpoint-lg) {
      display: block;
    }
  }
}

.menu-link__title {
  color: inherit;
  transition: color 0.2s;

  &:hover {
    color: $secondary;

    .menu-link__title-icon {
      fill: $secondary;
    }
  }
}

.menu-link__title-icon {
  position: absolute;
  top: 12px;
  left: 0;
  display: block;
  width: 16px;
  max-height: 16px;
  margin: 4px 0;
  transition: fill 0.2s;

  @media (max-width: $breakpoint-lg) {
    top: 16px;
    left: 10px;
    width: 14px;
  }
}

.menu-link__description {
  @include text--sm;

  margin-top: 8px;
  color: $primary65;
}

.menu-link__additional {
  @include text--sm;

  margin-top: 16px;
  color: $primary65;

  ul li {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.menu-link__additional-btn {
  margin-top: 16px;
  color: $primary;
}

.menu-link__links,
.menu-link__documents {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.menu-link__documents {
  .s-document {
    display: -webkit-box;
    padding-left: 0;
    background: none;

    span {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.menu-link__links-item,
.menu-link__documents-item {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: $primary;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  &:hover {
    color: $secondary;
  }
}
</style>